import { Gender } from './../constants/Gender';
import { GenderCoefficient } from './../constants/GenderCoefficients';
import { getAgeCoefficient } from './ageCoefficient';

export const getPromileFromGrams = (gender: Gender, weight: number, age: number, alcoholGrams: number) => {
    const ageCoefficient = getAgeCoefficient(age);
    return alcoholGrams / (weight * (GenderCoefficient[gender] * ageCoefficient));
};
